import { getMethod, postMethod } from "../../utils/api";
import {
  accessTokenAPIUrl,
  apiHeaderWithSiteId,
  changePasswordUrl,
  checkSupervisorUrl,
  forgotPasswordAPIUrl,
  getAccountDetailsAPIUrl,
  getCustomerArchiveStatusAPIUrl,
} from "../../utils/urls";
import {
  isAuthenticated,
} from "../selectors/auth.selector";
import { loadingEnd, loadingStart, loggedOut } from "./root.actions";

export const authActionTypes = {
  FETCH_CHECK_SUPERVISOR: "FETCH_CHECK_SUPERVISOR",
  CUSTOMER_ARCHIVE_SUCCESS: "CUSTOMER_ARCHIVE_SUCCESS",
  VALIDATE_TOKEN_SUCCESS: "VALIDATE_TOKEN_SUCCESS",
  CHANGE_PASSWORD_TOKEN_SUCCESS: "CHANGE_PASSWORD_TOKEN_SUCCESS",
  FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",
  ACCOUNT_DETAILS_SUCCESS: "ACCOUNT_DETAILS_SUCCESS",
};

const fetchCheckSupervisorSuccessAction = (data, isAuth) => {
  return {
    type: authActionTypes.FETCH_CHECK_SUPERVISOR,
    isAuth,
    data,
  };
};

const validateTokenSuccessAction = (
  token,
  userType,
  isAuth,
  changePasswordRequired
) => {
  return {
    type: authActionTypes.VALIDATE_TOKEN_SUCCESS,
    isAuth,
    userType,
    token,
    changePasswordRequired,
  };
};

const changePasswordSuccessAction = (isAuth, token) => {
  return {
    type: authActionTypes.CHANGE_PASSWORD_TOKEN_SUCCESS,
    isAuth,
    token,
  };
};

const forgotPasswordSuccessAction = (token, isAuth) => {
  return {
    type: authActionTypes.FORGOT_PASSWORD_SUCCESS,
    isAuth,
    token,
  };
};

const customerArchiveSuccessAction = (data, isAuth) => {
  return {
    type: authActionTypes.CUSTOMER_ARCHIVE_SUCCESS,
    isAuth,
    data,
  };
};

// Login api Call
export const fetchGetAccessToken = (payload) => (dispatch) => {
  dispatch(loadingStart());
  return postMethod(accessTokenAPIUrl, payload).then((data) => {
    if (data && data.success === false) {
      // throw new Error(data.msg);
      dispatch(loadingEnd());

      return data;
    } else {
      let changePasswordRequired = data.changePasswordRequired
        ? data.changePasswordRequired
        : false;
      dispatch(
        validateTokenSuccessAction(
          data.token,
          data.userType,
          true,
          changePasswordRequired
        )
      );
      dispatch(loadingEnd());
      return data;
    }
  });
};

// checkSupervisor api Call
export const fetchGetCheckSupervisor =
  (token, isAuth) => (dispatch, getState) => {
    const latestState = getState();
    const updateIsAuth = isAuth ? isAuth : isAuthenticated(latestState);
    let headerData = { ...latestState.auth.authenticatedNav };

    dispatch(loadingStart());

    return getMethod(checkSupervisorUrl)
      .then((data) => {
        headerData.associatedCustomers = data.associatedCustomers;
        // if (
        //   headerData.associatedCustomers.length === 1 &&
        //   headerData.associatedCustomers[0].blocked
        // ) {
        //   dispatch(fetchCheckSupervisorSuccessAction(headerData, isAuth));
        // } else {
        // dispatch(
        //   validateTokenSuccessAction(
        //     token,
        //     userType,
        //     true,
        //     changePasswordRequired
        //   )
        // );
        dispatch(fetchCheckSupervisorSuccessAction(headerData, updateIsAuth));
        // }
        return data;
      })
      .catch((err) => {
        console.log(err);
        dispatch(loadingEnd());
      });
  };

// Customer Archive Status api Call
export const getCustomerArchiveStatus =
  (token, isAuth) => (dispatch, getState) => {
    dispatch(loadingStart());
    return getMethod(getCustomerArchiveStatusAPIUrl)
      .then((data) => {
        dispatch(customerArchiveSuccessAction(data, isAuth));
        return data;
      })
      .catch((err) => console.log(err));
  };

export const updateLoginDetails =
  (token, userType, changePasswordRequired) => (dispatch) => {
    dispatch(loadingStart());
    dispatch(
      validateTokenSuccessAction(token, userType, true, changePasswordRequired)
    );
    dispatch(loadingEnd());
  };

export const fetchLogout = () => async (dispatch) => {
  dispatch(loadingStart());
  dispatch(loggedOut());
  localStorage.clear();
  dispatch(validateTokenSuccessAction("", false));
  if (apiHeaderWithSiteId["AssociatedCustomer"]) {
    delete apiHeaderWithSiteId["AssociatedCustomer"];
  }
};

// Forgotpassword api Call
export const forgotPassword = (payload) => (dispatch) => {
  dispatch(loadingStart());
  return postMethod(forgotPasswordAPIUrl, payload)
    .then((data) => {
      if (data && data.success === false) {
        dispatch(loadingEnd());
        return data;
      } else {
        dispatch(forgotPasswordSuccessAction(data.token, true));
        dispatch(loadingEnd());
        return data;
      }
    })
    .catch((err) => console.log(err));
};

// ChangePassword api Call
export const postChangePassword = (payload, token) => (dispatch) => {
  dispatch(loadingStart());
  return postMethod(changePasswordUrl, payload).then((data) => {
    if (data && data.success === false) {
      // throw new Error(data.msg);
      dispatch(loadingEnd());
      return data;
    } else {
      let isAuth = token ? true : false;
      let tokenData = data.newToken ? data.newToken : "";
      dispatch(changePasswordSuccessAction(isAuth, tokenData));
      dispatch(loadingEnd());
      return data;
    }
  });
};

export const clearArchiveDataAction = (token) => async (dispatch, getState) => {
  dispatch(loadingStart());
  if (token) {
    let latestState = getState();
    const isAuth = isAuthenticated(latestState);
    if (latestState.auth.archiveData) {
      latestState.auth.archiveData.archiveBox = "";
      latestState.auth.archiveData.contract = "";
    }
    const data = latestState.auth.archiveData;
    dispatch(customerArchiveSuccessAction(data, isAuth));
  }
};

// Clear REDUX on Change Customer
export const clearReduxDataAction = (token) => async (dispatch, getState) => {
  dispatch(loadingStart());
  if (token) {
    let latestState = getState();
    if (latestState.homePage) {
      latestState.homePage = null;
    }
    if (latestState.cart) {
      latestState.cart.items = [];
    }
    // To clear the cartItems
    if (latestState.cartItems) {
      latestState.cartItems.items = [];
    }
    if (latestState.auth.changePasswordRequired) {
      latestState.auth.changePasswordRequired = false;
    }
    if (latestState.product) {
      latestState.product.items.items = [];
      latestState.product.items.orderType = null;
      latestState.product.items.totalCount = null;
    }
    if (latestState.brandSubBrand) {
      latestState.brandSubBrand.brand = null;
      latestState.brandSubBrand.subBrand = null;
    }
    if (latestState.orderHistory) {
      latestState.orderHistory.items = [];
    }
    if (latestState.creditAmount) {
      latestState.creditAmount.items = [];
    }
  }
};

const fetchAccountDetailsSuccessAction = (data) => {
  return {
    type: authActionTypes.ACCOUNT_DETAILS_SUCCESS,
    data,
  };
};

export const getAccountDetailsAPI = () => async (dispatch) => {
  try {
    let data = await getMethod(getAccountDetailsAPIUrl);
    dispatch(fetchAccountDetailsSuccessAction(data));
    return data;
  } catch (error) {
    console.log(error);
  }
};
